import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { RESOURCES } from 'OpsCenter/app.constants';
import { Area } from 'OpsCenter/merchant-tools/models/area';
import { MigrationRequest } from 'OpsCenter/merchant-tools/models/migration-request';
import { Table } from 'OpsCenter/merchant-tools/models/table';
import { IntegrationPartnerSource } from 'OpsCenter/merchant-tools/models/integrationPartnerSource';

@Injectable()
export class MigrationToolService {

  constructor(private httpClient: HttpClient) {
  }

  public getAreas(merchantId: number): Observable<Area[]> {
    return this.httpClient.get(`${RESOURCES.MERCHANT}/${merchantId}/areas/`).pipe(
      map((area: any) => area.areas));
  }

  public changeArea(merchantId: number, body: MigrationRequest): Observable<Object> {
    return this.httpClient.post(`${RESOURCES.SUPPORT}/${merchantId}/reservations/change-area`, body);
  }

  public getTablesFromArea(merchantId: number, areaId: number): Observable<Table[]> {
    return this.httpClient.get(`${RESOURCES.MERCHANT}/${merchantId}/areas/${areaId}/objects`).pipe(
      map((objects: any) => objects.objects));
  }

  public changeTable(merchantId: number, body: MigrationRequest): Observable<any> {
    return this.httpClient.post(`${RESOURCES.SUPPORT}/${merchantId}/reservations/change-table`, body);
  }
  public getExternalPartnerSources(): Observable<{ sources: IntegrationPartnerSource[], subSources: any[] }> {
    return this.httpClient.get(RESOURCES.MERCHANT + '/sources').pipe(
      map((objects: any) => ({
        sources: objects.sources,
        subSources: objects.subSources
      }))
    );
  }
  public startIntegrationPartnerMigration(publicId: number , selectedIntegrationPartnerSource: string, externalId: string, subSource): Observable<Object> {
    const urlWithoutSubSource = `${RESOURCES.MERCHANT}/external-partner?publicId=${publicId}&sourceId=${selectedIntegrationPartnerSource}&externalMerchantId=${externalId}`
    const urlWithSubSource = `${RESOURCES.MERCHANT}/external-partner?publicId=${publicId}&sourceId=${selectedIntegrationPartnerSource}&externalMerchantId=${externalId}&subSourceId=${subSource}`;
    const url = subSource ? urlWithSubSource : urlWithoutSubSource;
    return this.httpClient.post(url, null);
  }
}



// WEBPACK FOOTER //
// ./src/app/merchant-tools/migration-form/services/migration-tool.service.ts